module.exports = __webpack_public_path__ + "static/media/logo.faa4c22c.jpg";